/* import numOne from "../../../Assets/Images/questions/questionSix/numOne.svg";
import numTwo from "../../../Assets/Images/questions/questionSix/numTwo.svg";
import numThree from "../../../Assets/Images/questions/questionSix/numThree.svg";
import numFourPlus from "../../../Assets/Images/questions/questionSeven/numFourPlus.svg"; */

export const numBathsData = [
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numOne_jkcns8.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numTwo_amwmnz.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numThree_q3gwkd.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642172370/AquaHeat/Quote%20Icons/question%207/numFourPlus_c82swh.svg",
  },
];
